import React from 'react';

import { AuthContext } from 'App';

import sendRequest from 'rest/sendRequest';

/**
 * @returns {function(relativePath: string, method: string, body?: any, config?: object): Promise<any>}
 */
export default function useREST() {
  const authContext = React.useContext(AuthContext);

  return React.useCallback(
    (path, method, body, cfg) => sendRequest(path, method, body, cfg, authContext),
    [authContext]
  );
}
